import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { setGameScore } from "../../api/api";

export function SetScoreModal(props) {
    const [homePoints, setHomePoints] = useState(null);
    const [awayPoints, setAwayPoints] = useState(null);

    const handleSubmit = (event) => {
        event.preventDefault();

        setGameScore(props.game, homePoints, awayPoints).then((games) => {
            props.refreshGames(games);
        }).finally(() => {
            props.setShow(false);
        });
    };

    if (!props.game) {
        return <></>
    }

    return (
        <Modal show={props.show} onHide={() => props.setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Set Score</Modal.Title>
            </Modal.Header>

            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="setScoreForm.HomePoints">
                        <Form.Label>{props.game.home_team}</Form.Label>
                        <Form.Control type="text" onChange={(e) => setHomePoints(parseInt(e.target.value))} />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="setScoreForm.AwayPoints">
                        <Form.Label>{props.game.away_team}</Form.Label>
                        <Form.Control type="text" onChange={(e) => setAwayPoints(parseInt(e.target.value))} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="ms-auto" onClick={() => props.setShow(false)}>Cancel</Button>
                    <Button variant="primary" type="submit" onClick={handleSubmit}>Set Score</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}
